import { graphql } from '../gql';

export const getCompletedPopupEventDetails = graphql(`
  query GetCompletedPopupEventDetails($input: GetEventVendorsInput!) {
    getEventVendors(input: $input) {
      error {
        code
        message
      }
      eventVendors {
        ... on PopupEventVendor {
          id
          confirmed
          productType
          sales {
            gfsCents
            totalCashPaymentsCents
            avgCustomerPaidCents
            mealsSold
            foodTopSales(limit: 10) {
              cents
              count
              name
              percentGfs
            }
          }
          mealPrep {
            prepFor
          }
          vendor {
            id
            internalName
            address {
              id
              address1
              address2
              city
              state
              zipCode
              country
            }
          }
          popupEvent {
            id
            status
            startTime: eventStartTime
            endTime: eventEndTime
            productType
            setupTime
            account {
              name
            }
          }
          eventLocation {
            id
            stationType
            setupTime
            serviceStartTime
            location {
              id
              name
              buildingAddressNotes
              cafeLocation {
                id
                name
              }
              building {
                id
                name
                address {
                  id
                  address1
                  address2
                  city
                  state
                  zipCode
                  country
                }
              }
            }
          }
        }
      }
    }
  }
`);
